import { useClientHandle, type UseQueryArgs } from '@urql/vue';

import {
  type MmaLoggedQueryVariables,
  type MmaLoggedQuery,
  MmaLoggedDocument,
} from '~/graphql/mma/generated/graphql';

const useMmaLogged = (
  options?: Ref<Omit<UseQueryArgs<MmaLoggedQuery, MmaLoggedQueryVariables>, 'query' | 'variables'>>,
) => useClientHandle().useQuery<MmaLoggedQuery>({
  query: MmaLoggedDocument,
  ...options,
});

export default useMmaLogged;
